import Vue from "vue";
import dayjs from "dayjs";

Vue.filter("parseDate", (value) => dayjs(value).format("DD/MM/YYYY HH:mm:ss"));
Vue.filter("parseOnlyDate", (value) => dayjs(value).format("DD/MM/YYYY"));
Vue.filter("phoneFormatted", (value) =>
  value.replace(/[^0-9]/g, "").replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3")
);
